import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
/**
 * @todo Api回傳格式
 */
export interface GenerateFidoQRCodeResp extends GeneralResp {
    qrCode: string; //base64src
    countSec: number;
}

/**
 * @todo FIDO 產生QRCode
 */
const GenerateFidoQRCode = (branch: string): Promise<GenerateFidoQRCodeResp> => {
    const url = RouteUrlList.API_FidoGenerate.path;
    const data = {
        branch: branch
    };
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.false,
            skipIdletimeout: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<GenerateFidoQRCodeResp>) => {
        return res.data;
    });
};

export default GenerateFidoQRCode;
